type ValuesOf<T> = T[keyof T];

// https://www.iso.org/iso-3166-country-codes.html
// https://www.iso.org/obp/ui/#search
const CountryCode = {
  GreatBritain: 'GB',
  France: 'FR',
  Russia: 'RU',
  Unknown: '',
  ArabEmirates: 'AE',
  UnitedStates: 'US',
} as const;

type TCountryCodes = ValuesOf<typeof CountryCode>;

export { CountryCode };
export type { TCountryCodes };
